import React, { Component } from 'react';
import PropTypes from 'prop-types';
import appConfigs from '@nerdwallet/app-config';
import { Tracking as nwTracking } from '@nerdwallet/nw-client-lib';

class Safe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      info: null,
    };
  }

  componentDidCatch(error, info) {
    this.setState({ error, info });
  }

  handleError() {
    const errorMessage = this.state.error.toString();
    const { componentStack } = this.state.info;

    if (appConfigs.CONFIG_ENV !== 'production') {
      return (
        <div>
          <h2>{errorMessage}</h2>
          <div>Component Stack Error Details:</div>
          <pre>{componentStack}</pre>
        </div>
      );
    }

    nwTracking.errorEvent({
      code: 'RenderingError',
      message: errorMessage,
      additionalData: JSON.stringify(componentStack),
    });

    return null;
  }

  render() {
    return this.state.error ? this.handleError() : this.props.children;
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
Safe.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Safe;
